import { useState, useCallback } from 'react'
import { authService } from '@/services'

export const useLogin = () => {
  const [loadingLogin, setLoadingLogin] = useState(false)

  const login = async formData => {
    setLoadingLogin(true)
    try {
      const response = await authService.login(formData)
      return response?.data
    } finally {
      setLoadingLogin(false)
    }
  }
  return { loadingLogin, login }
}

export const useRefreshToken = () => {
  const [loadingRefreshToken, setLoadingRefreshToken] = useState(false)

  const refreshToken = async () => {
    setLoadingRefreshToken(true)
    try {
      const response = await authService.refreshToken()
      return response?.data
    } finally {
      setLoadingRefreshToken(false)
    }
  }
  return { loadingRefreshToken, refreshToken }
}

export const useLogout = () => {
  const [loadingLogout, setLoadingLogout] = useState(false)

  const logout = async () => {
    setLoadingLogout(true)
    try {
      const response = await authService.logout()
      return response?.data
    } finally {
      setLoadingLogout(false)
    }
  }
  return { loadingLogout, logout }
}

export const useResetPassword = () => {
  const [loadingResetPassword, setLoadingResetPassword] = useState(false)

  const resetPassword = async formData => {
    setLoadingResetPassword(true)
    try {
      const response = await authService.resetPassword(formData)
      return response?.data
    } finally {
      setLoadingResetPassword(false)
    }
  }
  return { loadingResetPassword, resetPassword }
}

export const useLoginWithMagicLink = () => {
  const [loadingLoginWithMagicLink, setLoadingLoginWithMagicLink] =
    useState(false)

  const loginWithMagicLink = async formData => {
    setLoadingLoginWithMagicLink(true)
    try {
      const response = await authService.sendMagicLink(formData)
      return response?.data
    } finally {
      setLoadingLoginWithMagicLink(false)
    }
  }
  return { loadingLoginWithMagicLink, loginWithMagicLink }
}

export const useRequestMagicLink = () => {
  const [loadingRequestMagicLink, setLoadingRequestMagicLink] = useState(false)

  const requestMagicLink = async formData => {
    setLoadingRequestMagicLink(true)
    try {
      const response = await authService.requestMagicLink(formData)
      return response
    } finally {
      setLoadingRequestMagicLink(false)
    }
  }
  return { loadingRequestMagicLink, requestMagicLink }
}

export const useGetDonor = () => {
  const [donor, setDonor] = useState({})
  const [loadingDonor, setLoadingDonor] = useState(false)

  const getDonor = useCallback(async () => {
    setLoadingDonor(true)
    try {
      const response = await authService.getCurrentDonor()
      setDonor(response?.data)
    } catch (error) {
      const status = error?.response?.status
      if (status === 401) {
        setDonor({})
        return
      }
      throw error
    } finally {
      setLoadingDonor(false)
    }
  }, [])

  return { donor, setDonor, loadingDonor, getDonor }
}
